import React from 'react';
import { useIntl } from 'react-intl';
import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';

export const RequestOptions = ({ options, canUsePrivate, onChange }) => {
  const { formatMessage } = useIntl();

  return (
    <div className="request-video-options">
      {canUsePrivate && (
        <Tooltip title={formatMessage({ id: 'requestVideo_private_tooltip' })}>
          <FormControlLabel
            label={formatMessage({ id: 'requestVideo_private_label' })}
            control={
              <Checkbox
                checked={options.isPrivate}
                onChange={(event) => onChange({ isPrivate: event.target.checked })}
              />
            }
          />
        </Tooltip>
      )}
    </div>
  );
};
